module.exports = __webpack_public_path__ + "img/RESTEASY.63f06dd5.png";